export default "<p>\n  ete works!\n</p>\n";